export default __webpack_public_path__ + "static/media/White board.041300df.gif";